import { useQuery, UseQueryOptions } from 'react-query'

import { AxiosError } from 'axios'
import ApiCall from 'services/ApiCall'

import useUrlQuery, { UseUrlQueryOptions } from 'helpers/QueryUrl/useUrlQuery'

export interface GetAllEvent {
  id: number
}

type useAllResult = {
  data: any
  result: GetAllEvent[]
}

type TQueryFnData = useAllResult
type TError = AxiosError

function useGetAllMenu(
  urlOptions?: UseUrlQueryOptions,
  options?: UseQueryOptions<TQueryFnData, TError>,
) {
  const urlQuery = useUrlQuery(urlOptions)
  const queryKey = ['getAllMenu', urlOptions, options]

  const query = useQuery<TQueryFnData, TError>(
    queryKey,
    () =>
      ApiCall.Menu.get(urlQuery.transformUrl('?')).then((res) => {
        return res.data
      }),
    {
      ...options,
      keepPreviousData: true,
    },
  )

  return {
    ...query,
    data: query?.data?.data,
    length: query?.data?.result?.length,
    helpers: urlQuery,
  }
}

export default useGetAllMenu
